/*
Note(Diego): When a blob is created from a file we fetch, this is stored in memory.
We need to revokeObjectURL when we are done viewing the file, otherwise it will
result in a memory leak. Given files can have an arbitrarily large size, the leak can be
significant. This wrapper class helps encapsulate view and revoke functionality
More info here: https://github.com/omnea-digital/omnea-app/pull/9125#discussion_r2102708575
 */
export class BlobUrlHandle {
  private objectUrl: string

  constructor(blob: Blob) {
    this.objectUrl = URL.createObjectURL(blob)
  }

  get url() {
    return this.objectUrl
  }

  revoke() {
    URL.revokeObjectURL(this.url)
  }
}
